export default __webpack_public_path__ + "static/media/paymentMethodVisa.7ff8c8ed.svg";